import { render, staticRenderFns } from "./UserProfilePage.vue?vue&type=template&id=aaa3590a&scoped=true&"
import script from "./UserProfilePage.vue?vue&type=script&lang=ts&"
export * from "./UserProfilePage.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfilePage.vue?vue&type=style&index=0&id=aaa3590a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa3590a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
